/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IStickyConnection {
        name: string;
        id: number;
        leftBlock: IBlock;
        rightBlock: IBlock;
        origBlockConnection: IBlockConnection;
        destBlockConnection: IBlockConnection;
        href: string;
        isConnected: () => boolean;
    }

    export interface INewMultiplePresetPaths {
        name: string;
        password: string;
        blockConnectionCoupleIds: IBlockConnectionCouple[];
    }

    export interface IBlockConnectionCouple {
        originId: number;
        destinationId: number;
    }

    export interface INewStickyConnection {
        name: string;
        origBlockConnectionId: number;
        destBlockConnectionId: number;
    }

    export class StickyConnection implements IStickyConnection {

        public href: string;
        public id: number;
        public name: string;
        public leftBlock: IBlock;
        public rightBlock: IBlock;
        public origBlockConnection: IBlockConnection;
        public destBlockConnection: IBlockConnection;
        /** Origin nodes for preset paths that are in the source of the pipe*/
        public static SRC_PRESETPATH_ORIG: string[]  = [
            BlockTypeNaturalKey.VIRT_SRT_TX_LSTN,
        ];
        /** Destination nodes for preset paths that are in the source of the pipe*/
        public static SRC_PRESETPATH_DEST: string[]  = [
            BlockTypeNaturalKey.SRT_GW_RX_CALL,
        ];


        public static Empty(): StickyConnection {
            return new StickyConnection();
        }

        constructor() {
            // empty constructor
        }

        public isConnected(): boolean {
            if (this.destBlockConnection && this.origBlockConnection) {
                return this.destBlockConnection.connected || this.origBlockConnection.connected;
            } else {
                return false;
            }
        }

    }
}
